import {z} from 'zod'

export const DailyActivitySchema = z.object({
  date: z.string(),
  validated: z.number(),
  pending: z.number(),
  deleted: z.number(),
  cancelled: z.number(),
})

export const DailyReportSchema = z.object({
  date: z.string(),
  done: z.number(),
  partial: z.number(),
  notdone: z.number(),
  missing: z.number(),
  upcoming: z.number(),
})

export const NetworkDashboardSchema = z.object({
  kpis: z.object({
    totalActivities: z.number(),
    toApprove: z.number(),
  }),
  dailyActivities: z.array(DailyActivitySchema),
  dailyReports: z.array(DailyReportSchema),
  byActivityType: z.array(
    z.object({activityType: z.string(), count: z.number()}),
  ),
  byTeam: z.array(
    z.object({
      teamId: z.string(),
      teamName: z.string(),
      teamColor: z.string(),
      count: z.number(),
    }),
  ),
})
